import { useFormik } from "formik";
import React from "react";
import { toast } from "react-toastify";
import Button from "shared/Button";
import InputField from "shared/InputField";
import * as Yup from "yup";

const Contact = () => {
  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      phone: "",
      comment: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string()
        .matches(/^\w+( \w+)+$/, "Please enter a first name and last name only")
        .required("This field is required"),
      email: Yup.string().email("invalid Email").required("Email is Required"),
      phone: Yup.number("Must be a number").required(
        "Phone Number is required"
      ),
      comment: Yup.string().required("Please leave us comment"),
    }),
    onSubmit: (values) => {
      // const body = {
      //   fullName: values.fullName,
      //   email: values.email,
      //   phone: values.phone,
      //   comment: values.comment,
      // };
      toast.success("Thank you for dropping your comment!");
    },
  });
  return (
    <div className="px-16 max-[450px]:px-8 bg-[#FAFAFA] py-16 flex max-md:flex-wrap justify-center items-start gap-6 mt-20">
      <div className="w-1/2 max-md:w-full">
        <div className="flex flex-col">
          <p className="uppercase text-[30px] leading-[50px] font-bold">
            Want to get in touch with us? our team is happy to assist you
          </p>
          <p className="text-[#7A7A7A] leading-[26px] text-[18px]">
            Ask about TrueKeepers, donations, NGOs or anything else. Our trained
            reps are standing by, ready to help.
          </p>
        </div>
      </div>
      <div className="w-1/2 max-md:w-full">
        <form onSubmit={formik.handleSubmit}>
          <div className="flex flex-col gap-6">
            <InputField
              type="text"
              name="fullName"
              placeholder="First Name & Last Name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.fullName}
            />
            {formik.touched.fullName && formik.errors.fullName ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.fullName}
              </p>
            ) : null}
            <InputField
              type="text"
              name="phone"
              placeholder="Phone Number"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.phone}
            />
            {formik.touched.phone && formik.errors.phone ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.phone}
              </p>
            ) : null}
            <InputField
              type="email"
              name="email"
              placeholder="Email Address"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.email}
              </p>
            ) : null}
            <textarea
              className="px-4 py-1 bg-white outline-none border border-[#CCC] rounded-lg"
              rows="8"
              cols="50"
              name="comment"
              placeholder="Please leave your comments or messages here"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.comment}
            />
            {formik.touched.comment && formik.errors.comment ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.comment}
              </p>
            ) : null}
            <div className="flex justify-center">
              <Button type="submit" className="bg-[#FFFFFF]">
                Submit
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
